'use client';

import { useEffect, useState } from 'react';
import { useStore } from 'zustand';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { ProfileSheet } from './header-profile.sheet.component';

import { Button } from '@/components/ui/button/button.component';
import { authStore } from '@/store/auth.store';
import { modalsOpeningStore, setOpenSignInModal } from '@/store/modal';
import { SignInModal } from '@/app/(main)/_components/sign-in-modal/sign-in-modal.component';
import { EnvironmentNameEnum, getEnvironmentName } from '@/config/environment';

export function NavbarProfile() {
  const [mounted, setMounted] = useState(false);
  const isLoggedIn = useStore(authStore, (state) => state.computed.isLoggedIn);
  const openSignInModal = useStore(
    modalsOpeningStore,
    (state) => state.signInModalIsOpen,
  );
  const signInModalInitialStep = useStore(
    modalsOpeningStore,
    (state) => state.signInModalInitialStep,
  );

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleSignIn = () => {
    setOpenSignInModal(true);
  };

  if (getEnvironmentName() === EnvironmentNameEnum.PRODUCTION) {
    return null;
  }

  if (!mounted) {
    return null;
  }

  return (
    <>
      {!isLoggedIn
        ? (
            <>
              <Button
                data-testid={DataTestIdEnum.LOGIN_BUTTON}
                variant="secondary"
                color="primary"
                className="text-sm md:text-base h-8"
                onClick={handleSignIn}
              >
                Entrar
              </Button>
              <SignInModal
                isOpen={openSignInModal}
                setIsOpen={() => setOpenSignInModal(false)}
                initialStep={signInModalInitialStep}
              />
            </>
          )
        : (
            <>
              <ProfileSheet />
            </>
          )}
    </>
  );
}
